var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.2 496.2",
    style: {
      enableBackground: "new 0 0 496.2 496.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M496.2,248.1C496.2,111.1,385.1,0,248.1,0S0,111.1,0,248.1s111.1,248.1,248.1,248.1 S496.2,385.1,496.2,248.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3FBBD8"
    },
    points: "306.4,352.4 189.6,352.4 208.3,320.3 248.1,315.1 287.9,320.3 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F2F4"
    },
    d: "M248.1,496.2c70.2,0,133.6-29.2,178.7-76c-2.8-15.1-5.6-28.9-8.3-37.4 c-8.5-27.3-81.2-49.3-170.8-49.3s-161.5,22-170,49.3c-2.6,8.5-5.5,22.2-8.3,37.4C114.5,467,177.9,496.2,248.1,496.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78DDF4"
    },
    d: "M247.7,333.4c-1.4,0-2.9,0-4.3,0c-0.4,0-0.8,0-1.1,0c-1.1,0-2.1,0-3.2,0c-0.2,0-0.5,0-0.7,0 c-19.7,0.3-37.9,1.8-52.9,4.1c0,0,4,37.9,4,58.6l58.5,69l58.3-68.9c0-42.6-0.1-58.9-0.1-58.9C289.5,334.8,270.3,333.4,247.7,333.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A379"
    },
    d: "M287,282.1h-77.8c12.1,36.6,1,53.3,1,53.3l26.9,6.1h22l26.9-6.1C286,335.4,274.9,318.7,287,282.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B1818"
    },
    d: "M248.1,340.2l-15.7,4.7c0,0,5.4,25.6,15.7,25.6c10.3,0,15.7-25.6,15.7-25.6L248.1,340.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B1818"
    },
    d: "M248.1,468.9c0,0,16.1-29.4,23.7-45.8l-19.7-65.7H244l-19.5,65.4 C232.1,439.3,248.1,468.9,248.1,468.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M336.4,175.2c0-92.4-39.5-113.6-88.3-113.6c-48.7,0-88.3,21.2-88.3,113.6c0,31.3,6.2,55.8,15.5,74.7 c20.4,41.6,55.7,56.1,72.8,56.1s52.4-14.5,72.8-56.1C330.2,231,336.4,206.5,336.4,175.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919"
    },
    d: "M247.6,292.9h0.5C247.9,292.9,247.8,292.9,247.6,292.9L247.6,292.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919"
    },
    d: "M248.6,292.9L248.6,292.9c-0.2,0-0.3,0-0.5,0H248.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M170.4,238.7c-8.4,1.4-14.4,0.1-19.1-27.7s1.7-31.5,10.1-32.9L170.4,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M325.9,238.7c8.4,1.4,14.3,0.1,19.1-27.7c4.8-27.8-1.7-31.5-10.1-32.9L325.9,238.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5A173"
    },
    d: "M274.8,257c0,2.6-11.9,9.5-26.7,9.5s-26.7-7-26.7-9.5c0-1.6,8.5-6.1,14.1-6.9 c3.6-0.5,12.5,2.9,12.5,2.9s8.8-3.4,12.4-2.9C266.2,250.9,274.8,257,274.8,257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D89364"
    },
    d: "M274.8,257c0,2.6-11.9,12.4-26.7,12.4s-26.7-9.9-26.7-12.4c0,0,10.9,1.3,26.7,1.3 S274.8,257,274.8,257z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M336.4,175.2c0-92.4-30.3-116.1-88.3-116.1s-88.3,23.7-88.3,116.1l39.8-33.1c0,0,26.5,0,48.5,0 s46.2-35.3,46.2-35.3L336.4,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M165.5,140.8c-4.2,10.9-5.6,24.4-5.6,37.5c0,0,8.8-1.9,8.8,2.6l2.8,27.6l3.9-1.9 c-0.2-23,4.9-68,4.9-68L165.5,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M330.8,140.8c4.2,10.9,5.6,24.4,5.6,37.5c0,0-8.8-1.9-8.8,2.6l-2.8,27.6l-3.9-1.9 c0.2-23-4.9-66.2-4.9-66.2L330.8,140.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261D17"
    },
    d: "M206.9,169.6c-19.1,0-34.7,3.3-34.7,27.2c0,15.1,8.6,30.1,34.7,30.1c19.1,0,34.7-15.1,34.7-30.1 S226.1,169.6,206.9,169.6z M206.9,221c-20.7,0-27.5-12-27.5-23.9c0-19,12.3-21.6,27.5-21.6s27.5,9.7,27.5,21.6 C234.4,209,222.1,221,206.9,221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4C4A4"
    },
    d: "M206.9,175.5c-15.2,0-27.5,2.7-27.5,21.6c0,11.9,6.8,23.9,27.5,23.9c15.2,0,27.5-12,27.5-23.9 S222.1,175.5,206.9,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CCB0"
    },
    d: "M206.9,175.5c-15.2,0-27.5,2.7-27.5,21.6c0,10,4.8,20,18.5,23l16.5-43.8 C212,175.8,209.5,175.5,206.9,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4C4A4"
    },
    d: "M234.4,197.1c0-9.9-8.5-18.2-20-20.8L198,220.1c2.6,0.6,5.6,0.9,9,0.9 C222.1,221,234.4,209,234.4,197.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261D17"
    },
    d: "M176.4,188.7c-0.9,0-1.8-0.4-2.5-1.1l-13.3-14.5c-1.3-1.4-1.2-3.6,0.2-4.8c1.4-1.3,3.6-1.2,4.8,0.2 l13.3,14.5c1.3,1.4,1.2,3.6-0.2,4.8C178.1,188.4,177.3,188.7,176.4,188.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261D17"
    },
    d: "M320.4,188.7c0.9,0,1.8-0.4,2.5-1.1l13.3-14.5c1.3-1.4,1.2-3.6-0.2-4.8c-1.4-1.3-3.6-1.2-4.8,0.2 L317.9,183c-1.3,1.4-1.2,3.6,0.2,4.8C318.8,188.4,319.6,188.7,320.4,188.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261D17"
    },
    d: "M254.5,196.8c0,15.1,15.5,30.1,34.7,30.1c26.1,0,34.7-15.1,34.7-30.1c0-23.9-15.5-27.2-34.7-27.2 S254.5,181.8,254.5,196.8z M261.7,197.1c0-11.9,12.3-21.6,27.5-21.6s27.5,2.7,27.5,21.6c0,11.9-6.8,23.9-27.5,23.9 C274,221,261.7,209,261.7,197.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4C4A4"
    },
    d: "M289.2,175.5c15.2,0,27.5,2.7,27.5,21.6c0,11.9-6.8,23.9-27.5,23.9c-15.2,0-27.5-12-27.5-23.9 S274,175.5,289.2,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CCB0"
    },
    d: "M289.2,175.5c-2.6,0-5.1,0.3-7.5,0.8c-11.5,2.6-20,10.9-20,20.8c0,9.9,8.4,19.8,19.9,22.9l16.5-44 C295.3,175.6,292.3,175.5,289.2,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4C4A4"
    },
    d: "M298.1,220.1c13.7-3,18.5-13,18.5-23c0-15-7.7-19.8-18.5-21.1l-16.5,44c2.4,0.7,4.9,1,7.6,1 C292.5,221,295.5,220.7,298.1,220.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261D17"
    },
    d: "M260.3,200.6h-21.7c-0.2,0-6-11.9-5.7-11.9h30.2C263.4,188.7,260.5,200.6,260.3,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261D17"
    },
    d: "M258.4,200.7c-3-2.1-6.6-4.2-10.5-4.2c-2.9,0-5.8,1.6-8.2,2.8c-3.9,2-3.9,12.7-3.9,12.7 c2.2-4.7,7-7.7,12.2-7.7c5.1,0,9.9,3,12.2,7.7C260.1,212.1,261.3,202.7,258.4,200.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.5,337.4L311.5,337.4L311.5,337.4L311.5,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M298.5,335.9L298.5,335.9L298.5,335.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ECFF2"
    },
    d: "M306.5,336.6l-18.6-16.2l-39.8,19.8c0,0,58.1,32.8,58.4,32.6V336.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C9DEE2"
    },
    points: "358,345.9 293.3,324.9 248.1,469.1 330,373.1 319,362.1 335.5,362.1 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ECFF2"
    },
    d: "M189.7,336.6l18.6-16.2l39.8,19.9c0,0-58.1,32.8-58.3,32.6v-36.3H189.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C9DEE2"
    },
    points: "138.1,345.9 203.1,324.9 248.1,469.1 166.1,373.1 177.1,362.1 160.6,362.1 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3F3F"
    },
    d: "M214.8,312c-34.9,8.6-59.8,30.2-59.8,55.4v85.3h5v-85.3c0-22.7,22.7-42.2,54.7-50.3 C214.9,315.5,214.9,313.8,214.8,312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3F3F"
    },
    d: "M281.4,312c0,1.8,0,3.5,0.1,5.1c32.1,8.1,54.7,27.6,54.7,50.3v15.7h5v-15.6 C341.2,342.2,316.3,320.6,281.4,312z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5E5E5E"
    },
    cx: 157.6,
    cy: 444,
    r: 16.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 157.6,
    cy: 444,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5E5E5E"
    },
    cx: 157.6,
    cy: 444,
    r: 10.3
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 157.6,
    cy: 444,
    r: 7.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69696B"
    },
    d: "M349.4,459.3c-5.8,0-13.5-0.1-20.1-3.6c-8.3-4.4-12.6-13.1-12.6-25.7v-21.6h4V430 c0,11.2,3.4,18.5,10.4,22.2c6,3.2,13.4,3.2,18.9,3.2h0.6v4H350C349.8,459.3,349.6,459.3,349.4,459.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69696B"
    },
    d: "M354.9,457.3c0,2.3-1.9,4.2-4.2,4.2l0,0c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2l0,0 C352.9,453,354.9,454.9,354.9,457.3L354.9,457.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8D8E"
    },
    d: "M327.8,459.2c-0.2,0-0.4,0-0.6,0h-0.6v-4h0.6c5.4,0,12.9,0,18.9-3.2c7-3.7,10.4-11,10.4-22.2v-21.6 h4v21.6c0,12.7-4.2,21.3-12.6,25.7C341.3,459.1,333.6,459.2,327.8,459.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D8D8E"
    },
    d: "M322.4,457.2c0,2.3,1.9,4.2,4.2,4.2l0,0c2.3,0,4.2-1.9,4.2-4.2l0,0c0-2.3-1.9-4.2-4.2-4.2l0,0 C324.3,452.9,322.4,454.8,322.4,457.2L322.4,457.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3F3F"
    },
    d: "M358.5,410.8c-1.4,0-2.5-1.1-2.5-2.5v-6.6c0-9.6-7.8-17.4-17.4-17.4s-17.4,7.8-17.4,17.4v6.6 c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5v-6.6c0-12.3,10-22.4,22.4-22.4s22.4,10,22.4,22.4v6.6C361,409.6,359.9,410.8,358.5,410.8z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMd);
export default __webpack_public_path__ + "static/media/avatar-md.eb5f22155e10777d2496460f8426ceb6.svg";
export { ForwardRef as ReactComponent };